import { createVerificationButtons } from '@/Containers/CrmSection/Components/VerificationButtons'
import { Hint } from '@/Ship/Components/Hint'

import { CARRIER_FIELD_LABELS } from '../Contracts/CarrierFieldLabels'
import { CARRIER_REST_URL } from '../Contracts/ICarrier'

import type { CrmVerificationOwnerConfig } from '@/Containers/CrmSection/Components/VerificationButtons'

/**
 * Верифікація перевізника (`SPEC-010` §6.3, §9.5): кнопки й модалки — спільні
 * для власників CRM, тексти — перевізника. Успіхи — дослівно з легасі
 * (`uk:398,418,451,467`), крім відправки: у легасі там стояло «Клієнта
 * успішно…» (D-23).
 *
 * Хто що бачить, вирішує бек (`_permissions`, `SPEC-010` §14): відправляє —
 * той, хто змінює перевізника (R-06), підтверджує й відхиляє — A, SL, K,
 * чорний список — лише A.
 */
export const CARRIER_VERIFICATION_CONFIG: CrmVerificationOwnerConfig = {
    restUrl: CARRIER_REST_URL,
    fieldLabels: CARRIER_FIELD_LABELS,
    forwarderResource: 'Setting.ListLegalEntity',
    texts: {
        verifyModalTitle: 'Верифікація перевізника',
        forwarderLabel: CARRIER_FIELD_LABELS.forwarder,
        blacklistConfirmTitle: 'Додати перевізника до чорного списку?',
        blacklistConfirmText:
            'Якщо перевізника верифіковано, відмітку «Ким верифіковано» й дату верифікації буде знято. ' +
            'Повернути перевізника можна кнопкою «З чорного списку» — після цього його доведеться верифікувати знову.',
        success: {
            send_to_verification: 'Перевізника успішно відправлено на верифікацію.',
            verify: 'Перевізника успішно верифіковано.',
            reject_verification: 'Верифікацію успішно відхилено.',
            blacklist: 'Перевізника успішно додано до чорного списку.',
            unblacklist: 'Перевізника успішно видалено з чорного списку.',
        },
    },
    verifyHint: (
        <Hint id="crm.carrier.verify-contract">
            Після підтвердження з'явиться договір із цим експедитором, номером і датою — на вкладці «Договори».
        </Hint>
    ),
}

/** Обробник `onButtons` картки перевізника в перегляді. */
export const CarrierVerificationButtons = createVerificationButtons(CARRIER_VERIFICATION_CONFIG)
